import React from 'react';

const SvgHeart = (props) => (
  <svg
    className="Heart_svg__icon Heart_svg__icon-heart"
    fill="none"
    viewBox="0 0 19.576 16.945"
    stroke="currentColor"
    strokeWidth={1.5}
    width="1em"
    height="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.063 2.149a4.5 4.5 0 0 0 0 6.364l7.682 7.682 7.682-7.682a4.5 4.5 0 0 0-6.364-6.364L9.745 3.467 8.427 2.149a4.5 4.5 0 0 0-6.364 0z"
    />
  </svg>
);

export default SvgHeart;
